import { DateTime } from 'luxon';

export function getWorkdaysInMonth(date: DateTime): number {
  const daysInMonth = date.daysInMonth!;
  let workdays = 0;

  for (let day = 1; day <= daysInMonth; day++) {
    const current = date.set({ day });
    const weekday = current.weekday;

    if (weekday >= 1 && weekday <= 5) {
      workdays++;
    }
  }

  return workdays;
}
